module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAGklEQVR4AWMYRmAmYTh4NVAORkNpNJSGDQAAWISBGVCcD9kAAAAASUVORK5CYII="